(function () {
  'use strict';

  var reproPage = document.querySelector('[data-repro-service]');

  function findInShadow(root, selectors, depth) {
    if (!root || depth > 5) return null;
    for (var i = 0; i < selectors.length; i++) {
      try {
        var direct = root.querySelector(selectors[i]);
        if (direct) return direct;
      } catch (e) {}
    }

    var nodes = [];
    try { nodes = root.querySelectorAll('*'); } catch (e) { return null; }
    for (var n = 0; n < nodes.length; n++) {
      if (nodes[n].shadowRoot) {
        var found = findInShadow(nodes[n].shadowRoot, selectors, depth + 1);
        if (found) return found;
      }
    }
    return null;
  }

  function findChatButton() {
    var selectors = [
      '[data-spec="toggle-button"]',
      '.chat-app > button',
      'button.chat-toggle',
      'button.activator',
      'button[aria-label*="chat" i]',
      'button[aria-label*="message" i]'
    ];

    var hosts = [
      document.getElementById('ShopifyChat'),
      document.querySelector('inbox-online-store-chat'),
      document.querySelector('shopify-chat')
    ];

    for (var h = 0; h < hosts.length; h++) {
      var host = hosts[h];
      if (!host) continue;
      if (host.shadowRoot) {
        var inShadow = findInShadow(host.shadowRoot, selectors, 0);
        if (inShadow) return inShadow;
      }
      var inHost = findInShadow(host, selectors, 0);
      if (inHost) return inHost;
    }

    // Legacy placeholder used while Inbox is loading.
    var dummy = document.getElementById('dummy-chat-button-iframe');
    if (dummy) {
      try {
        var doc = dummy.contentDocument || dummy.contentWindow.document;
        var legacy = doc && (doc.querySelector('#dummy-chat-button') || doc.querySelector('button'));
        if (legacy) return legacy;
      } catch (e) {}
    }

    return null;
  }

  function showUnavailable(button) {
    var shell = button.closest('[data-repro-chat-shell]');
    var fallback = shell && shell.querySelector('[data-repro-chat-unavailable]');
    if (fallback) fallback.hidden = false;
  }

  function openInbox(button) {
    var tries = 0;
    var timer = window.setInterval(function () {
      tries += 1;
      var toggle = findChatButton();
      if (toggle) {
        window.clearInterval(timer);
        try { toggle.click(); } catch (e) { showUnavailable(button); }
        return;
      }
      if (tries >= 12) {
        window.clearInterval(timer);
        showUnavailable(button);
      }
    }, 250);
  }

  function hideInboxOutsideRepro() {
    if (reproPage) return;
    function hide() {
      var chat = document.getElementById('ShopifyChat') || document.querySelector('inbox-online-store-chat');
      if (chat) chat.style.setProperty('display', 'none', 'important');
      var dummy = document.getElementById('dummy-chat-button-iframe');
      if (dummy) dummy.style.setProperty('display', 'none', 'important');
    }
    hide();
    var observer = new MutationObserver(hide);
    observer.observe(document.documentElement, { childList: true, subtree: true });
    window.setTimeout(function () { observer.disconnect(); }, 15000);
  }

  document.addEventListener('DOMContentLoaded', function () {
    hideInboxOutsideRepro();
    document.querySelectorAll('[data-open-shopify-chat]').forEach(function (button) {
      button.addEventListener('click', function () { openInbox(button); });
    });
  });
})();
